import { ReactNode } from "react";

import useOnClickOutside from "src/hooks/useOnClickOutside";

interface IClickOutsideProps<T> {
    reference: React.RefObject<T>;
    onClickOutside: () => void;
    children: ReactNode;
}

export const ClickOutside = <T,>({
    children,
    reference,
    onClickOutside,
}: IClickOutsideProps<T>) => {
    useOnClickOutside([reference], onClickOutside);

    return children;
};
